<main class="ript-shell">
  <router-outlet />
</main>
